// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// # Default rows per page
export const ROWS_PER_PAGE = [5, 10, 15, 20]
